
import { StateService } from "@uirouter/angularjs";
import { Component, Input } from "angular-ts-decorators";
import { ILeague } from "../../../models/ILeague";
import { AuthService } from "../../../services/AuthService";
import template from "./template.html";

@Component({
  selector: "stNavigation",
  template,
})
export class NavigationComponent {
  static $inject: string[] = ["AuthService", "$state"];
  @Input() league: ILeague;

  constructor(
    private authService: AuthService,
    private $state: StateService
  ) {
  }

  async onLogin() {
    localStorage.setItem('seasonticker_login_redirect', JSON.stringify({ legacy_path: window.location.pathname }))
    this.authService.login();
  }

  async onLogout() {
    await this.authService.logout();
  }

}
